// extracted by mini-css-extract-plugin
module.exports = {"pageNumber":"pageNumber_pageNumber__pWVeL","next":"pageNumber_next__115uL","previous":"pageNumber_previous__3sJjv"};